import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import localforage from 'localforage';
import { FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import { combineReducers } from "redux";
import auth from "./slices/authSlice";
import { baseApi } from "../services/baseApi";

const allReducers = combineReducers({
    auth,
    [baseApi.reducerPath]: baseApi.reducer
});

export const rootReducer = (state, action) => {
    // createSlice emits "auth/logout"; the old "auth/log-out" never matched so
    // logout left the persisted Admin impersonation snapshot in IndexedDB.
    if (action.type === "auth/logout" || action.type === "auth/clear-cache") {
        localforage.removeItem("persist:root");
        return allReducers(undefined, action);
    }

    return allReducers(state, action);
}

const persistConfig = {
  key: 'root',
  storage: localforage,
  blacklist: [baseApi.reducerPath]
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
  reducer: persistedReducer,
  devTools: import.meta.env.DEV,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
      serializableCheck: {
          ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
  }).concat(baseApi.middleware)
});

export const persistor = persistStore(store);
